import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ThumbsUpDownIcon(props: IconProps) {
    return <Icon {...props} iconKey={"thumbs_up_down"}/>
}
